<p class="subtitle is-1">{{ ('legal-notice') | translate }}</p>
